import { fg } from '@atlassian/jira-feature-gating';
import getMeta from '@atlassian/jira-get-meta';

export const isSynthetic = () =>
	// Filter out synthetic tests using all known ways
	getMeta('ajs-is-synthetic') === 'true' || fg('forge_ui_synthetic_check');
